import bem from "easy-bem";
import React from "react";

import "./CountBadge.css";

const cn = bem("count-badge");

const MAX_DISPLAYED_COUNT = 99;

type CountBadgeProps = {
  count: number;
};

/** Красный кружок-счётчик. Ничего не рендерит при count <= 0. */
const CountBadge: React.FC<CountBadgeProps> = ({ count }) => {
  if (count <= 0) {
    return null;
  }

  return (
    <span
      className={cn()}
      aria-hidden="true"
    >
      {count > MAX_DISPLAYED_COUNT ? `${MAX_DISPLAYED_COUNT}+` : count}
    </span>
  );
};

export default CountBadge;
